module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 43
// module chunks = 0